/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DataSource, ServerDataSource } from 'angular2-smart-table';
import { map } from 'rxjs/operators';

@Injectable()
export class HttpService {

  get API_BASE_URL(): string {
    return environment.API_BASE_URL;
  }

  constructor(private readonly http: HttpClient) {}

  getServerDataSource(uri: string): ServerDataSource {
    return new ServerDataSource(this.http, {
      endPoint: uri,
      dataKey: 'data',
      pagerPageKey: 'pagination[page]',
      pagerLimitKey: 'pagination[pageSize]',
      totalKey: 'meta.pagination.total',
      filterFieldKey: 'filters[#field#][$containsi]',
      sortFieldKey: 'sortFieldName',
      sortDirKey: 'sortDirection',
    });
  }

  get(endpoint: string, options?): Observable<any> {
    return this.http.get(`${this.API_BASE_URL}/${endpoint}`, options);
  }

  post(endpoint: string, data, options?): Observable<any> {
    return this.http.post(`${this.API_BASE_URL}/${endpoint}`, data, options);
  }

  put(endpoint: string, data, options?): Observable<any> {
    return this.http.put(`${this.API_BASE_URL}/${endpoint}`, data, options);
  }

  delete(endpoint: string, options?): Observable<any> {
    return this.http.delete(`${this.API_BASE_URL}/${endpoint}`, options);
  }

  getBlob(endpoint: string): Observable<Blob> {
    return this.http.get(`${this.API_BASE_URL}/${endpoint}`, { responseType: 'blob' });
  }

  /**
   * Upload a file to the standard upload endpoint.
   * Returns an observable that emits the server response (typically { url, name, ... }).
   */
  uploadFile(file: File): Observable<any> {
    const fd = new FormData();
    fd.append('files', file, file.name); // Strapi v5 expects 'files' key by default
    // POST to /api/upload (standard Strapi upload endpoint)
    return this.http.post(`${this.API_BASE_URL}/upload`, fd).pipe(
      map((res: any) => {
        // Strapi returns an array of uploaded file objects; take the first
        return Array.isArray(res) ? res[0] : res;
      })
    );
  }
}
